export default __webpack_public_path__ + "static/media/s5.119b63f1.png";